import {
  PATH_PERMISSIONS_ADMINISTRATION,
  PATH_PERMISSIONS_OPERATOR,
} from "~/core/constants/paths";

export const PATH_USER_ACCOUNT = "/user-account";
export const PATH_USER_ACCOUNT_LANGUAGE = `${PATH_USER_ACCOUNT}/language`;
export const PATH_USER_ACCOUNT_PROFILE = `${PATH_USER_ACCOUNT}/profile`;

export const PATH_USER_ACCOUNT_ADMINISTRATION = "/user-account-administration";
export const PATH_USER_ACCOUNT_ADMINISTRATION_LANGUAGE = `${PATH_USER_ACCOUNT_ADMINISTRATION}/language`;
export const PATH_USER_ACCOUNT_ADMINISTRATION_PROFILE = `${PATH_USER_ACCOUNT_ADMINISTRATION}/profile`;

export const PATH_USER_MANAGEMENT = "/user-management";
export const PATH_USER_MANAGEMENT_GROUPS = `${PATH_USER_MANAGEMENT}/groups`;
export const PATH_USER_MANAGEMENT_GROUPS_CODE = `${PATH_USER_MANAGEMENT_GROUPS}/:code`;
export const PATH_USER_MANAGEMENT_USERS = `${PATH_USER_MANAGEMENT}/users`;
export const PATH_USER_MANAGEMENT_USERS_LOGIN = `${PATH_USER_MANAGEMENT_USERS}/:userLogin`;
export const PATH_USER_MANAGEMENT_PROFILES = `${PATH_USER_MANAGEMENT}/profiles`;
export const PATH_USER_MANAGEMENT_PROFILES_ID = `${PATH_USER_MANAGEMENT_PROFILES}/:profileId`;
export const PATH_USER_MANAGEMENT_PROFILES_ID_PERMISSIONS_ADMINISTRATION = `${PATH_USER_MANAGEMENT_PROFILES_ID}${PATH_PERMISSIONS_ADMINISTRATION}`;
export const PATH_USER_MANAGEMENT_PROFILES_ID_PERMISSIONS_OPERATOR = `${PATH_USER_MANAGEMENT_PROFILES_ID}${PATH_PERMISSIONS_OPERATOR}`;

export const GROUP_CODE_NEW = "new";
